import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { ROLES } from '../../utils/roles';
import SuperAdminDashboard from './SuperAdminDashboard';
import AdminDashboard from './AdminDashboard';
import VendorDashboard from './VendorDashboard';
import UserDashboard from './UserDashboard';
import LoadingSpinner from '../../components/LoadingSpinner';

function DashboardRouter() {
  const { user } = useAuth();
  if (!user) return <LoadingSpinner />;

  switch (user.role) {
    case ROLES.SUPER_ADMIN: return <SuperAdminDashboard />;
    case ROLES.ADMIN:
    case ROLES.STAFF:       return <AdminDashboard />;
    case ROLES.VENDOR:      return <VendorDashboard />;
    case ROLES.USER:
    default:                return <UserDashboard />;
  }
}

export default DashboardRouter;
